import {
  IsBoolean,
  IsDefined,
  IsInt,
  IsOptional,
  IsString
} from 'class-validator';
import { Type } from 'class-transformer';

export class GetFilteredProductsMerchantGroupDto {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantGroupId: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  page: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  limit: number;

  @IsOptional()
  @IsString()
  @Type(() => String)
  sortBy?: string;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  sortDESC?: boolean;

  @IsOptional()
  @IsString()
  @Type(() => String)
  search?: string;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  activeStatus?: boolean;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  brandId?: number;

}
